package com.eladfinish.bible.contest.screens.mikud.model

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.pirkei_format
import com.eladfinish.bible.contest.total_chapters_format
import dev.icerock.moko.resources.compose.stringResource
import dev.icerock.moko.resources.desc.Raw
import dev.icerock.moko.resources.desc.StringDesc

@Composable
fun MikudSummaryModel.toLocalizedStringDesc(): StringDesc {
    val details = buildString {
        books.forEach { book ->
            append(
                stringResource(
                    SharedRes.strings.pirkei_format,
                    book.name,
                    book.includedChaptersCount,
                    "\n",
                )
            )
            append(book.chaptersText)
            append("\n")
        }
    }

    val header = stringResource(
        SharedRes.strings.total_chapters_format,
        totalChapters,
        "\n\n",
    )

    return StringDesc.Raw(header + details)
}
